import { render, staticRenderFns } from "./TemplatePageGrid.vue?vue&type=template&id=7bff43a5&scoped=true&"
import script from "./TemplatePageGrid.vue?vue&type=script&lang=js&"
export * from "./TemplatePageGrid.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePageGrid.vue?vue&type=style&index=0&id=7bff43a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff43a5",
  null
  
)

export default component.exports